// Base configuration (optional but recommended)
import { getApiBaseUrl } from "src/config/endpoints";
import { buildAuthHeaders, handleJsonResponse } from "./httpUtils";

const API_BASE_URL = getApiBaseUrl();

// Helper function to handle fetch errors
export interface CustomerAccount {
  id: string;
  name: string;
  login_customer_id?: string; // Make it optional if it's not always present
  // Add other properties if they exist in the API response
}

// API functions
export const googleAdsService = {
  // 1. Fetch existing connection details
  fetchExistingConnection: async (tenant_id: string | null): Promise<any> => {
    const response = await fetch(
      `${API_BASE_URL}/gads/fetch-existing-account-details?tenant_id=${tenant_id}&api_key=${localStorage.getItem(
        "api_key"
      )}`,
      {
        method: "POST",
        headers: buildAuthHeaders("api_key"),
      }
    );
    return handleJsonResponse(response);
  },

  // 2. Get customer accounts list - FIXED INTERFACE
  fetchCustomers: async (
    access_token: string
  ): Promise<{ customer_accounts: CustomerAccount[] }> => {
    // Use the new interface here
    const response = await fetch(`${API_BASE_URL}/gads/customers`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify({ access_token }),
    });
    return handleJsonResponse(response);
  },

  // 3. Test the connection
  testConnection: async (params: {
    access_token: string;
    customer_id: string;
    tenant_id: string | null;
    user_id: string | null;
    login_customer_id: string;
  }): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/gads/test-connection`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify(params),
    });
    return handleJsonResponse(response);
  },

  // 4. Create the connection
  createConnection: async (params: {
    refresh_token: string;
    customer_id: string;
    tenant_id: string | null;
    manager_account_id: string;
    source: string;
    user_id: string | null;
    login_customer_id: string;
  }): Promise<any> => {
    const response = await fetch(`${API_BASE_URL}/gads/create-connection`, {
      method: "POST",
      headers: buildAuthHeaders("api_key"),
      body: JSON.stringify(params),
    });
    return handleJsonResponse(response);
  },

  // 5. Remove the connection
  removeConnection: async (tenant_id: string | null): Promise<any> => {
    const response = await fetch(
      `${API_BASE_URL}/remove-connection?tenant_id=${tenant_id}&source_name=google_ads&api_key=${localStorage.getItem(
        "api_key"
      )}`,
      {
        method: "POST",
        headers: buildAuthHeaders("api_key"),
      }
    );
    return handleJsonResponse(response);
  },
};

